api = require('../api.coffee').api()

class global.CompaniesResource extends ResourceBase
  @MODEL = Company
  @SINGULAR_RESOURCE_NAME = 'company'
  @PLURAL_RESOURCE_NAME = 'companies'

  index: (success, failure, params = {}) ->
    api.get "/companies", params, { success: @collectionSuccess(success), failure }

  get: (success, failure, params = {}) ->
    api.get "/companies/#{@getParamsId(params)}", params, { success: @memberSuccess(success), failure }

  verify: (success, failure, params = {}) ->
    api.post "/companies/#{@getParamsId(params)}/verify", params, { success: @memberSuccess(success), failure }

  create: (success, failure, params = {}) ->
    api.post "/companies", params, { success: @memberSuccess(success), failure }

  update: (success, failure, params = {}) ->
    api.put "/companies/#{@getParamsId(params)}", params, { success: @memberSuccess(success), failure }



// WEBPACK FOOTER //
// ./src/resources/companies.coffee